import { gql } from 'graphql-request';
import withFragments from 'utils/graphql';

import Logo from 'fragments/Logo';

export default withFragments(
  gql`
    query($id: Int, $contentType: String!, $token: String!, $currentPage: PositiveInt, $lat: Float, $lon: Float) {
      page(id: $id, contentType: $contentType, token: $token) {
        ... on AccommodationIndex {
          url
          title
          seoTitle
          seoDescription
          ... on AccommodationIndex {
            metaImage {
              url
            }
            metaTitle
            metaDescription
            logo {
              ...Logo
            }
          }
          breadcrumbs {
            title
            url
          }
        }
      }
      accommodations(perPage: 6, page: $currentPage, lat: $lat, lon: $lon) {
        items {
          site {
            port
            hostname
          }
          name
          url
          distance
          streetName
          postCode
          houseNumber
          city
          promotionImage {
            img: rendition(fill: "330x220-c100") {
              url
            }
          }
        }
        pagination {
          total
          count
          prevPage
          nextPage
          totalPages
          currentPage
        }
      }
    }
  `,
  { Logo },
);
